import React, {useEffect, useMemo, useState} from 'react';
import usePermissions from "../../../../../../services/Permissions";
import {useDispatch, useSelector} from "react-redux";
import {t} from "../../../../../../services/i18n";
import {HStack, Pressable, VStack} from "native-base";
import AppText from "../../../../../common/AppText";
import {GlobalStyleAttributes} from "../../../../../../styles/GlobalStyles";
import InfoTooltip from "../../../../../common/InfoTooltip";
import FormInput from "../../../../../common/FormInput";
import MultiSingleMenuWithSearch from "../../../../../common/MultiSingleMenuWithSearch";
import {Radio} from "antd";
import {Colors} from "../../../../../../styles/Colors";
import AdvanceSelect from "../../../../../common/AdvanceSelect";
import {HOK, IMMEDIATE, TRIAL, RELATIVE, FULL, ONETIME, TRACK_FULL, TRACK_RELATIVE} from "../../../../../../services/ConstHelper";
import {isBoxIL, isMobile} from "../../../../../../services/Helpers";
import { updateFlags } from '../../../../../../redux/stepperSlice';
import FoldableSettingSection from "../../../../../common/FoldableSettingSection";
import SimpleInput from "../../../../../common/SimpleInput";
import CustomCheckbox from "../../../../../common/CustomCheckbox";
import {ARBOX_INVOICES, invoicesTypes} from "../../../../../../services/ConstHelper";
import IncomeCardSelect from '../../../../Forms/Settings/IncomeCardSelect';

const SITE_SHOW_IMMEDIATE_PAYMENT = 'showImmediate'
const SITE_SHOW_HOK_PAYMENT = 'showHOK'
const SITE_SHOW_DEBT_PAYMENT = 'showDebt'
const SITE_HIDE_ALL_PAYMENTS = 'hideOnSite'

const PAYMENT_SECTION = 'PAYMENT_SECTION'
const DISPLAY_SECTION = 'DISPLAY_SECTION'
const HOK_RELATIVE_PAYMENT_SECTION = 'HOK_RELATIVE_PAYMENT_SECTION'
const IMMEDIATE_RELATIVE_PAYMENT_SECTION = 'IMMEDIATE_RELATIVE_PAYMENT_SECTION'
const SORT_CODE_SECTION = 'SORT_CODE_SECTION'
const REDIRECT_SECTION = 'REDIRECT_SECTION'
const INCOME_CARD_SECTION = 'INCOME_CARD_SECTION'

const SeriesPaymentOptions = (props) => {
    const { values, setFieldValue, errors, touched, showEditMessage, isEdit, showTrialOption, hasHideFullHugInSiteProp, showOnetimeOption, hideSiteDisplaySection = false, TrackCreationFlow = false} = props;
    const box = useSelector((state) => state.box.box);
    const [siteDisplayOption, setSiteDisplayOption] = useState(null);
    const [isReady, setIsReady] = useState(!isEdit); // if edit => not ready, else => ready!
    const [openedSection, setOpenedSection] = useState(PAYMENT_SECTION);
    const { has } = usePermissions();
    const dispatch = useDispatch()

    const hasHOKOption = useMemo(() => has('recurringPaymentActions'), []);
    const immediatePaymentOptions = useMemo(() => [{label: t('userPayNow'), value: 1}, {label: t('userEnterDebt'), value: 2}, {label: t('userPayNowOrDebt'), value: 3}], []);
    const selectedLocation = useMemo(() => {
        if(box && values.locations_box_fk) {
            return box.locations_box.find(l => l.id === values.locations_box_fk)
        }
    },[box, values.locations_box_fk])

    const currencySymbol = useMemo(() => selectedLocation?.currency_symbol,[selectedLocation])
    console.log('selectedLocation', selectedLocation)
    const allowOnlyDebt = useMemo(() => selectedLocation?.hasPayments === false, [selectedLocation]);
    const hasImmediate = useMemo(() => !values.isUnlimited, [values.isUnlimited]);
    const isGlobal = useMemo(() => !isBoxIL(), [box]);
    const hasArboxInvoice = useMemo(() => box?.rivhit_id == invoicesTypes[ARBOX_INVOICES], [box]);
    const hasPartial = useMemo(() => values?.multiDayConfig?.days?.length > 1 || values?.days?.length > 1, [values?.multiDayConfig, values?.days]);
    const fullPaymentValue = useMemo(() => TrackCreationFlow ? TRACK_FULL : FULL, [TrackCreationFlow]);
    const relativePaymentValue = useMemo(() => TrackCreationFlow ? TRACK_RELATIVE : RELATIVE, [TrackCreationFlow]);
    const defaultRelativePayment = useMemo(() => TrackCreationFlow ? TRACK_FULL : FULL, [TrackCreationFlow]);
    const taxes = useMemo(() => {
        if (selectedLocation && selectedLocation.taxes.length > 0) {
            return selectedLocation.taxes.reduce((acc, tax) => [...acc, {id: tax.id, name: `${tax.name} (${tax.percentage}%)`}],[])
        }
    },[selectedLocation])

    useEffect(() => {
        let paymentOptions = values.paymentOptions.length > 0 ? values.paymentOptions : []
        let shouldUpdate = false
        if(hasHOKOption && !values.paymentOptions.some(payment => payment.type === HOK)) {
            shouldUpdate = true
            paymentOptions.push({type: HOK, show_in_app: 0, price: values.isOneDay ? 1 : null, max_installments: 1, taxes: [], relative_payment: defaultRelativePayment, redirectLinkEnabled: false, redirectLink: null})
        }
        if(hasImmediate && !values.paymentOptions.some(payment => payment.type === IMMEDIATE)) {
            shouldUpdate = true
            paymentOptions.push({type: IMMEDIATE, show_in_app: 0, price: null, max_installments: 1, taxes: [], relative_payment: defaultRelativePayment, redirectLinkEnabled: false, redirectLink: null})
        }
        if(showTrialOption && !values.paymentOptions.some(payment => payment.type === TRIAL)) {
            shouldUpdate = true
            paymentOptions.push({type: TRIAL, show_in_app: 0, price: 0, max_installments: 1, taxes: [], redirectLinkEnabled: false, redirectLink: null})
        }
        if(showOnetimeOption && !values.paymentOptions.some(payment => payment.type === ONETIME)) {
            shouldUpdate = true
            paymentOptions.push({type: ONETIME, show_in_app: 0, price: 0, max_installments: 1, taxes: []})
        }

        if(!isReady || (paymentOptions.length && !siteDisplayOption)) {
            setIsReady(true)
            initEditSitePaymentOption(paymentOptions)
        }
        if(shouldUpdate) {
            if (isEdit) {
                // add new payment option
                dispatch(updateFlags({overrideValues: true}))
            }
            console.log('wht', paymentOptions, values.paymentOptions)
            setFieldValue('paymentOptions', paymentOptions)
        }
    }, [hasHOKOption, hasImmediate, values.paymentOptions]);

    useEffect(() => {
        if(values.paymentOptions) {
            if(siteDisplayOption) {
                handleShowOnSiteLogic()
            } else {
                const showInSite = values.paymentOptions.some(payment => [HOK, IMMEDIATE].includes(payment.type) && payment.show_in_app > 0)
                if(!showInSite) setSiteDisplayOption(SITE_HIDE_ALL_PAYMENTS)
            }
        }
    }, [siteDisplayOption]);

    useEffect(() => {
        if(has('hideFullHugByDefault') && hasPartial) {
            if(isEdit) {
                setFieldValue('hideFullHugInSite', hasHideFullHugInSiteProp)
            } else {
                setFieldValue('hideFullHugInSite', true)
            }
        } else if(has('hideFullHugByDefault') && !hasPartial) { //for changing number of days mid process (from multi to 1)
            setFieldValue('hideFullHugInSite', false)
        }
    }, [isEdit, hasPartial]);

    useEffect(() => {
        console.log('values, errors',values, errors)
    }, [values, errors]);

    const handleShowOnSiteLogic = () => {
        let indexHOK = findPaymentTypeIndex(HOK)
        let indexImmediate = findPaymentTypeIndex(IMMEDIATE)
        let HOKShowInApp
        let immediateShowInApp

        switch (siteDisplayOption) {
            case SITE_HIDE_ALL_PAYMENTS:
                HOKShowInApp = 0;
                immediateShowInApp = 0;
                break;
            case SITE_SHOW_HOK_PAYMENT:
                HOKShowInApp = 1;
                immediateShowInApp = 0;
                break;
            case SITE_SHOW_IMMEDIATE_PAYMENT:
                HOKShowInApp = 0;
                immediateShowInApp = values.paymentOptions[indexImmediate].show_in_app > 0 ? values.paymentOptions[indexImmediate].show_in_app : 1;
                break;
            case SITE_SHOW_DEBT_PAYMENT:
                HOKShowInApp = 0;
                immediateShowInApp = 2;
                break;
            default:
                break;
        }

        if(indexHOK !== -1) setFieldValue(`paymentOptions[${indexHOK}].show_in_app`, HOKShowInApp)
        if(indexImmediate !== -1) setFieldValue(`paymentOptions[${indexImmediate}].show_in_app`, immediateShowInApp)
        if(siteDisplayOption === SITE_HIDE_ALL_PAYMENTS) fullPaymentRedirectRadioChange('no-redirect', indexHOK, indexImmediate)
    }

    const initEditSitePaymentOption = (paymentOptions) => {
        const siteOption = paymentOptions.find(option => [HOK, IMMEDIATE].includes(option.type) && option.show_in_app > 0)
        let siteSelectedDisplay = SITE_HIDE_ALL_PAYMENTS;
        if(siteOption) {
            if(siteOption.type === HOK) {
                siteSelectedDisplay = SITE_SHOW_HOK_PAYMENT
            } else if(siteOption.type === IMMEDIATE && siteOption.show_in_app === 2 && allowOnlyDebt) {
                siteSelectedDisplay = SITE_SHOW_DEBT_PAYMENT
            } else if(siteOption.type === IMMEDIATE && siteOption.show_in_app >= 1) {
                siteSelectedDisplay = SITE_SHOW_IMMEDIATE_PAYMENT
            }
        }
        setSiteDisplayOption(siteSelectedDisplay)
    }

    const setSortCode = (val) => {
        for (let i = 0; i < values.paymentOptions.length; i++) {
            setFieldValue(`paymentOptions[${i}].sort_code`, val)
        }
        setFieldValue('sort_code', val)
    }

    const findPaymentTypeIndex = (type) => {
        return values.paymentOptions.findIndex(option => option.type === type)
    }

    const onSectionToggle = (sectionName) => {
        if(openedSection === sectionName) setOpenedSection(null)
        else setOpenedSection(sectionName)
    }

    const getError = (paymentType, propName) => {
        const typeIndex = findPaymentTypeIndex(paymentType)
        if(typeIndex !== -1 && errors.paymentOptions && touched.paymentOptions && errors.paymentOptions[typeIndex] && touched.paymentOptions[typeIndex]) {
            return errors.paymentOptions[typeIndex][propName]
        }
    }

    const fullPaymentRedirectRadioChange = (radio, indexHOK, indexImmediate) => {
        const allowed = radio === 'with-redirect'
        if(indexHOK >= 0) {
            setFieldValue(`paymentOptions[${indexHOK}].redirectLinkEnabled`, allowed)
            if(!allowed) setFieldValue(`paymentOptions[${indexHOK}].redirectLink`, null)
        }
        if(indexImmediate >= 0) {
            setFieldValue(`paymentOptions[${indexImmediate}].redirectLinkEnabled`, allowed)
            if(!allowed) setFieldValue(`paymentOptions[${indexImmediate}].redirectLink`, null)
        }
    }

    const fullPaymentRedirectLinkChange = (text, indexHOK, indexImmediate) => {
        if(indexHOK >= 0) {
            setFieldValue(`paymentOptions[${indexHOK}].redirectLink`, text)
        }
        if(indexImmediate >= 0) {
            setFieldValue(`paymentOptions[${indexImmediate}].redirectLink`, text)
        }
    }

    const getSummary = () => {
        let summary = '';
        let paymentOptionsText = `${t('series-payments-office')} ${siteDisplayOption === SITE_HIDE_ALL_PAYMENTS ? `${t('only')} ` : ''}`;
        if(values.paymentOptions && values.paymentOptions.length) {
            const options = values.paymentOptions.filter(mt => mt.type !== TRIAL && mt.type !== ONETIME && !(mt.type === HOK && values.isOneDay))
            options.map((option, i) => {
                paymentOptionsText += t(`series-payments-price-${option.type}-summary`, {price: `${(option.price || 0).toLocaleString()}${currencySymbol}`, max_installments: option.max_installments})
                if(option.type === HOK) {
                    paymentOptionsText += ` ${t(`series-HOK-summary-${option.relative_payment === relativePaymentValue ? 'relative' : 'full'}${values.isUnlimited ? '-unlimited' : ''}`)}`
                } else if(option.type === IMMEDIATE) {
                    paymentOptionsText += ` ${t(`series-immediate-summary-${option.relative_payment === relativePaymentValue ? 'relative' : 'full'}`)}`
                }
                
                if(i < options.length - 1) {
                    paymentOptionsText += ` ${t('and')} `
                }
            })
            summary = `${t(TrackCreationFlow ? 'track-payments-summary' : 'series-payments-summary', {paymentOptions: paymentOptionsText})}`
        }
        return summary
    }

    const renderHOKRelativePaymentSection = () => {
        const hokIndex = findPaymentTypeIndex(HOK)
        if(hasHOKOption && hokIndex >= 0 && !values.isOneDay) {
            return (
                <FoldableSettingSection header={t('relative-payment-section-header')}
                                        isOpen={openedSection === HOK_RELATIVE_PAYMENT_SECTION}
                                        onToggle={() => onSectionToggle(HOK_RELATIVE_PAYMENT_SECTION)}
                                        summary={t(`${values.paymentOptions[hokIndex].relative_payment}-payment-summary-selected`)}>
                    <VStack space={'0.5rem'}>
                        <Radio.Group name={'hug-relative-radio'} value={values.paymentOptions[hokIndex].relative_payment} onChange={e => setFieldValue(`paymentOptions[${hokIndex}].relative_payment`, e.target.value)}>
                            <VStack space={'0.8rem'}>
                                <Radio value={fullPaymentValue} size="sm"><AppText fontSize={GlobalStyleAttributes.fonts.heading3} color={Colors.newDesign.mainText}>{t(`hug-no-relative-radio${values.isUnlimited ? '-unlimited' : ''}`)}</AppText></Radio>
                                <Radio value={relativePaymentValue} size="sm"><AppText fontSize={GlobalStyleAttributes.fonts.heading3} color={Colors.newDesign.mainText}>{t(TrackCreationFlow ? 'track-hug-with-relative-radio' : `hug-with-relative-radio${values.isUnlimited ? '-unlimited' : ''}`)}</AppText></Radio>
                            </VStack>
                        </Radio.Group>
                    </VStack>
                </FoldableSettingSection>
            )
        }
        return <></>
    }

    const renderImmediateRelativePaymentSection = () => {
        if(TrackCreationFlow) return <></>
        const immediateIndex = findPaymentTypeIndex(IMMEDIATE)
        if(hasImmediate && immediateIndex >= 0 && !values.isOneDay) {
            return (
                <FoldableSettingSection header={t('immediate-relative-payment-section-header')}
                                        isOpen={openedSection === IMMEDIATE_RELATIVE_PAYMENT_SECTION}
                                        onToggle={() => onSectionToggle(IMMEDIATE_RELATIVE_PAYMENT_SECTION)}
                                        summary={t(`${values.paymentOptions[immediateIndex].relative_payment}-immediate-payment-summary-selected`)}>
                    <VStack space={'0.5rem'}>
                        <Radio.Group name={'hug-relative-immediate-radio'} value={values.paymentOptions[immediateIndex].relative_payment ?? fullPaymentValue} onChange={e => setFieldValue(`paymentOptions[${immediateIndex}].relative_payment`, e.target.value)}>
                            <VStack space={'0.8rem'}>
                                <Radio value={fullPaymentValue} size="sm"><AppText fontSize={GlobalStyleAttributes.fonts.heading3} color={Colors.newDesign.mainText}>{t('hug-no-relative-immediate-radio')}</AppText></Radio>
                                <Radio value={relativePaymentValue} size="sm"><AppText fontSize={GlobalStyleAttributes.fonts.heading3} color={Colors.newDesign.mainText}>{t('hug-with-relative-immediate-radio')}</AppText></Radio>
                            </VStack>
                        </Radio.Group>
                    </VStack>
                </FoldableSettingSection>
            )
        }
        return <></>
    }

    const renderFullHugRedirect = () => {
        if(!has('siteSuccessRedirect') || siteDisplayOption === SITE_HIDE_ALL_PAYMENTS) return null
        const immediateIndex = findPaymentTypeIndex(IMMEDIATE)
        const hokIndex = findPaymentTypeIndex(HOK)
        const options = values.paymentOptions.filter(mt => mt.type !== TRIAL)
        const hasRedirect = options.some(payment => payment.redirectLinkEnabled)
        const redirectLink = options[0].redirectLink

        return (
            <FoldableSettingSection header={t('full-hug-redirect-section-header')}
                                    infoTooltip={t('full-hug-redirect-section-tooltip')}
                                    isOpen={openedSection === REDIRECT_SECTION}
                                    onToggle={() => onSectionToggle(REDIRECT_SECTION)}
                                    summary={t(`full-hug-${hasRedirect ? 'with': 'no'}-redirect`)}
                                    error={hasRedirect && (getError(IMMEDIATE, 'redirectLink') || getError(HOK, 'redirectLink'))}>
                <VStack space={'0.2rem'} flex={1}>
                    <Radio.Group name={'fullHugRedirectSiteSetting-radio'} onChange={e => fullPaymentRedirectRadioChange(e.target.value, hokIndex, immediateIndex)} value={hasRedirect ? 'with-redirect' : 'no-redirect'}>
                        <VStack space={'0.5rem'}>
                            <Radio value="no-redirect" size="sm"><AppText fontSize={GlobalStyleAttributes.fonts.heading3} color={Colors.newDesign.mainText}>{t('no-redirect-label')}</AppText></Radio>
                            <Radio value="with-redirect" size="sm">
                                <HStack><AppText fontSize={GlobalStyleAttributes.fonts.heading3} color={Colors.newDesign.mainText}>{t('with-redirect-label')}</AppText></HStack>
                            </Radio>
                            {hasRedirect && <SimpleInput value={redirectLink} onChangeCallback={val => fullPaymentRedirectLinkChange(val, hokIndex, immediateIndex)} status={getError(IMMEDIATE, 'redirectLink') || getError(HOK, 'redirectLink') ? 'error' : null} placeholder={t('redirectMTPlaceholder')}/>}
                        </VStack>
                    </Radio.Group>
                </VStack>
            </FoldableSettingSection>
        )
    }

    return (
        <VStack flex={1} justifyContent={'space-between'} space={'1rem'}>
            {values.paymentOptions && values.paymentOptions.length > 0 &&
            <VStack space={'1rem'}>
                <FoldableSettingSection header={t('pricing')}
                                        isOpen={openedSection === PAYMENT_SECTION}
                                        onToggle={() => onSectionToggle(PAYMENT_SECTION)}
                                        summary={getSummary()}
                                        errorIcon={getError(IMMEDIATE, 'price') || getError(HOK, 'price') || getError(IMMEDIATE, 'max_installments')}
                >
                    <VStack space={'1rem'}>
                        {values.paymentOptions.map((option, i) => (
                            <React.Fragment key={`series-payment-option-${i}`}>
                            {hasHOKOption && option.type === HOK && !values.isOneDay &&
                                <VStack space={'0.5rem'}>
                                    <HStack>
                                        <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('recurring-payment-settings')}</AppText>
                                        <InfoTooltip title={t('recurring-payment-tooltip')}/>
                                    </HStack>
                                    <VStack space={'0.5rem'}>
                                        <FormInput
                                            value={option.price}
                                            onChangeCallback={(val) => setFieldValue(`paymentOptions[${i}].price`, val)}
                                            label={t('price-per-month')}
                                            width={'6rem'}
                                            formatAddon={currencySymbol}
                                            inputType={'float'}
                                            error={getError(HOK, 'price')}
                                            containerProps={{mb: 0}}
                                            errorHeight={'unset'}
                                            labelProps={{style:{fontFamily: 'Ploni'}}}
                                        />
                                        {taxes &&
                                        <VStack space={'0.2rem'} w={'12rem'}>
                                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText}>{t('taxes')}</AppText>
                                            <MultiSingleMenuWithSearch options={taxes} onChange={(val) => setFieldValue(`paymentOptions[${i}].taxes`, val)} placeholder={t('taxSelectorLabel')} defaultValue={option.taxes}/>
                                        </VStack>
                                        }
                                    </VStack>
                                    {showEditMessage && <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.newDesign.darkGrey}>{t(`edit-payment-option-price${isGlobal ? '' : '-global'}${isMobile ? '-mobile' : ''}`)}</AppText>}
                                </VStack>
                            }
                            {hasImmediate && option.type === IMMEDIATE &&
                                <VStack space={'0.5rem'}>
                                    <HStack>
                                        <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('immediate-payment-settings')}</AppText>
                                        <InfoTooltip title={t('immediate-payment-tooltip')}/>
                                    </HStack>
                                    <VStack space={'0.5rem'}>
                                        <HStack space={'0.5rem'}>
                                            <FormInput
                                                value={option.price}
                                                onChangeCallback={(val) => setFieldValue(`paymentOptions[${i}].price`, val)}
                                                label={t('total-price')}
                                                width={'6rem'}
                                                formatAddon={currencySymbol}
                                                inputType={'float'}
                                                error={getError(IMMEDIATE, 'price')}
                                                containerProps={{mb: 0}}
                                                errorHeight={'unset'}
                                                labelProps={{style:{fontFamily: 'Ploni'}}}
                                            />
                                            {!allowOnlyDebt && !isGlobal &&
                                            <FormInput
                                                value={option.max_installments}
                                                onChangeCallback={(val) => setFieldValue(`paymentOptions[${i}].max_installments`, val)}
                                                label={t('max-installments')}
                                                width={'4rem'}
                                                numericOnly={true}
                                                min={1}
                                                max={24}
                                                error={getError(IMMEDIATE, 'max_installments')}
                                                containerProps={{mb: 0}}
                                                errorHeight={'unset'}
                                                labelProps={{style:{fontFamily: 'Ploni'}}}
                                            />}
                                        </HStack>
                                        {taxes &&
                                        <VStack space={'0.2rem'} w={'12rem'}>
                                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText}>{t('taxes')}</AppText>
                                            <MultiSingleMenuWithSearch options={taxes} onChange={(val) => setFieldValue(`paymentOptions[${i}].taxes`, val)} placeholder={t('taxSelectorLabel')} defaultValue={option.taxes}/>
                                        </VStack>
                                        }
                                    </VStack>
                                    {showEditMessage && <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.newDesign.darkGrey}>{t(`edit-payment-option-price${isGlobal ? '' : '-global'}${isMobile ? '-mobile' : ''}`)}</AppText>}
                                </VStack>
                            }
                            </React.Fragment>
                        ))}
                        {has('hideFullHugByDefault') && hasPartial && <CustomCheckbox text={t('show-full-hug-only-in-manage')} isChecked={values.hideFullHugInSite} onChange={val => setFieldValue('hideFullHugInSite',val)}/>}
                    </VStack>
                </FoldableSettingSection>
                {renderHOKRelativePaymentSection()}
                {renderImmediateRelativePaymentSection()}
                {!hideSiteDisplaySection &&
                <FoldableSettingSection header={t('show-on-site')}
                                        isOpen={openedSection === DISPLAY_SECTION}
                                        onToggle={() => onSectionToggle(DISPLAY_SECTION)}
                                        summary={t(`${siteDisplayOption}-site-display-summary`)}>
                    <Radio.Group name={'show-payment-on-site-radio'} value={siteDisplayOption} onChange={e => setSiteDisplayOption(e.target.value)}>
                        <VStack space={'0.8rem'}>
                            <Radio value={SITE_HIDE_ALL_PAYMENTS} size="sm"><AppText fontSize={GlobalStyleAttributes.fonts.heading3} color={Colors.newDesign.mainText}>{t('hideOnSite-radio')}</AppText></Radio>
                            {hasHOKOption && !values.isOneDay && <Radio value={SITE_SHOW_HOK_PAYMENT} size="sm"><AppText fontSize={GlobalStyleAttributes.fonts.heading3} color={Colors.newDesign.mainText}>{t('showHOK-radio')}</AppText></Radio>}
                            {hasImmediate &&
                            <>
                                {allowOnlyDebt ?
                                    <Radio value={SITE_SHOW_DEBT_PAYMENT} size="sm"><AppText fontSize={GlobalStyleAttributes.fonts.heading3} color={Colors.newDesign.mainText}>{t('showDebt-radio')}</AppText></Radio>
                                    :
                                    <HStack alignItems={'start'}>
                                        <Radio value={SITE_SHOW_IMMEDIATE_PAYMENT} size="sm"/>
                                        <Pressable onPress={() => setSiteDisplayOption(SITE_SHOW_IMMEDIATE_PAYMENT)}>
                                            <VStack space={'0.5rem'}>
                                                <AppText fontSize={GlobalStyleAttributes.fonts.heading3} color={Colors.newDesign.mainText}>{t('showImmediate-radio')}</AppText>
                                                {siteDisplayOption === SITE_SHOW_IMMEDIATE_PAYMENT &&
                                                <VStack w={'16rem'}>
                                                    <AdvanceSelect options={immediatePaymentOptions} initValue={values.paymentOptions[findPaymentTypeIndex(IMMEDIATE)].show_in_app} onChange={(val) => setFieldValue(`paymentOptions[${findPaymentTypeIndex(IMMEDIATE)}].show_in_app`, val?.value)}/>
                                                </VStack>}
                                            </VStack>
                                        </Pressable>
                                    </HStack>
                                }
                            </>}
                        </VStack>
                    </Radio.Group>
                </FoldableSettingSection>}
                {has('sortCodeActions') &&
                    <FoldableSettingSection header={t('sort-code-section-header')}
                                            isOpen={openedSection === SORT_CODE_SECTION}
                                            onToggle={() => onSectionToggle(SORT_CODE_SECTION)}
                                            summary={t(TrackCreationFlow ? `${values.sort_code ? 'has': 'no'}-track-sort-code` : `${values.sort_code ? 'has': 'no'}-sort-code`, {value: values.sort_code})}
                                            error={touched.sort_code ? errors.sort_code : null}>
                        <SimpleInput value={values.sort_code}
                                     onChangeCallback={setSortCode}
                                     numericOnly
                                     status={errors.sort_code && touched.sort_code ? 'error' : null}
                        />
                    </FoldableSettingSection>}
                {hasArboxInvoice && has('accountCardsSettings') && values.locations_box_fk &&
                    <FoldableSettingSection header={t('income-card')}
                                            isOpen={openedSection === INCOME_CARD_SECTION}
                                            onToggle={() => onSectionToggle(INCOME_CARD_SECTION)}
                                            summary={t('income-card-section-summary')}>
                        <VStack space={'1rem'}>
                            {values.paymentOptions.map((option, i) => (
                                <IncomeCardSelect
                                    key={`income-card-${option.type}-${i}`}
                                    label={t(`series-payments-${option.type}-account-card`)}
                                    locationId={values.locations_box_fk}
                                    value={option.income_card}
                                    onChange={(val) => setFieldValue(`paymentOptions[${i}].income_card`, val)}
                                />
                            ))}
                        </VStack>
                    </FoldableSettingSection>}
                {renderFullHugRedirect()}
            </VStack>}
        </VStack>
    );
};

export default SeriesPaymentOptions;